import { HttpParameter } from "./Models/HttpParameter";
import { HttpResult } from "./Models/HttpResult";
import Config from "../../Configs/Environments/Environments";
import axios, { CancelTokenSource } from "axios";
import {
    getRestuarantRefId,
    getToken,
} from "src/Shared/Utils/LocalStorageUtils";
import { APPLICATION_NAME } from "src/constant";
import { pathOr } from "ramda";
import { HttpRequestHeader } from "src/Shared/Enums/HttpRequestHeader";
import { logout } from "../Auth/Service/Auth.service";

interface header {
    [key: string]: string;
}

const createRequest = () => {
    let cancel: CancelTokenSource;
    return async (
        parameter: HttpParameter,
        isCancellable = false,
        shouldCancelExistingRequests = false
    ): Promise<HttpResult> => {
        const headers: header = {};

        headers[HttpRequestHeader.Authorization] = `Bearer ${getToken()}`;
        headers[HttpRequestHeader.ApplicatioName] = APPLICATION_NAME;
        headers[HttpRequestHeader.RestaurantRefId] = getRestuarantRefId();
        if (parameter.headers) {
            parameter.headers.forEach((h) => {
                headers[h.key] = h.value;
            });
        }
        const route = Config.httpService.serviceUrls[parameter.subRoute];
        const url = `${route}${parameter.endPoint}`;

        if (shouldCancelExistingRequests && cancel) {
            cancel.cancel();
        }
        if (isCancellable) {
            cancel = axios.CancelToken.source();
        }
        const axiosIns = axios({
            url: url,
            method: parameter.method,
            headers: { ...headers },
            data: parameter.body,
            cancelToken: isCancellable ? cancel.token : undefined,
        });
        try {
            const response = await axiosIns;
            if (response.status === 200 || response.status === 201) {
                return {
                    success: true,
                    response: response.data,
                    headers: response.headers,
                } as HttpResult;
            }
            return {
                success: true,
                response: response.data,
                headers: response.headers,
            } as HttpResult;
        } catch (error: any) {
            if (axios.isCancel(error)) {
                return { success: false, isCancelled: true } as HttpResult;
            }
            if (error.response?.status === 401) {
                logout(getRestuarantRefId());
                window.location.reload();
            }
            return {
                success: false,
                errorResponse: error?.response?.data,
                headers: error?.headers,
                errorMessage: error?.response?.data
                    ? pathOr("", [0, "message"], error?.response?.data)
                    : error?.message,
            } as HttpResult;
        }
    };
};

export const request = createRequest();
